// src/api/user-service/preferenceService.js
import client from '../client';

/**
 * Create user preferences
 * @param {Object} data - { language?: string, theme?: string, notifications?: Object }
 * @returns {Promise<Object>} Created preference data
 */
export const createMyPreference = async (data) => {
  return client.post('/users/me/preferences', data).then(res => res.data);
};

/**
 * Get current user preferences
 * @returns {Promise<Object>} User preference data
 */
export const getMyPreference = async () => {
  return client.get('/users/me/preferences').then(res => res.data);
};

/**
 * Update user preferences
 * @param {Object} data - { language?: string, theme?: string, notifications?: Object }
 * @returns {Promise<Object>} Updated preference data
 */
export const updateMyPreference = async (data) => {
  return client.put('/users/me/preferences', data).then(res => res.data);
};

/**
 * Delete user preferences
 * @returns {Promise<Object>} Deletion confirmation
 */
export const deleteMyPreference = async () => {
  return client.delete('/users/me/preferences').then(res => res.data);
};
